export default __webpack_public_path__ + "0d0fb6a9c981080b32856aac01ac80d8.png";